require("utility/diff_display.scss");

var DiffDisplay = function(props) {
	var text = props.text;

	var className = props.className || "";
	className += " diffDisplay";

	return (
		<span className={ className }>
			{ splitText(text) }
		</span>
	);
};

function splitText(text) {
	var match = text.match(changePattern);

	if (match) {
		var start = match.index;
		var end = start + match[0].length;

		var before = text.substring(0, start).trim();
		var matchText = text.substring(start, end).trim();
		var after = text.substring(end).trim();

		if (before.length) {
			var beforeContent = splitText(before);
		}
		if (after.length) {
			var afterContent = splitText(after);
		}

		if (matchText.startsWith("{+")) {
			// Except for leading '"(+' and trailing '"}'
			var innerText = matchText.substring(3, matchText.length - 2);
			var innerContent = (
				<span className="addition">{ innerText }</span>
			);

		} else if (matchText.startsWith("{-")) {
			// Except for leading '"(-' and trailing '"}'
			var innerText = matchText.substring(3, matchText.length - 2);
			var innerContent = (
				<span className="subtraction">{ innerText }</span>
			);

		} else if (matchText.includes('" >> "')) {
			var parts = matchText.split('" >> "');
			var preText = parts[0].substring(2);
			var postText = parts[1].substring(0, parts[1].length - 2);

			var innerContent = (
				<span>
					<span className="subtraction">{ preText }</span>{" "}
					<span className="addition">{ postText }</span>
				</span>
			);
		}

	} else {
		var innerContent = (
			<span>{ text }</span>
		);
	}

	return (
		<span>
			{ beforeContent } { innerContent } { afterContent }
		</span>
	);
}

var changePattern = /\{[^\{\}]*\}/;

DiffDisplay.propTypes = StrictPropTypes({
	className: PropTypes.string,
	text: PropTypes.string.isRequired
});

module.exports = DiffDisplay;



// WEBPACK FOOTER //
// ./modules/components/utility/DiffDisplay.js